import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';
import { AxiosResponse } from "axios";

export class ReportService extends BaseService{
	constructor() {
		super('/Report');
	}

	public getExcell(filter: ReportFilter): Promise<AxiosResponse<any>> {
		return super.getFileByFilter(filter, 'generate-monthly');
	}

	public getExcellFee(filter: ReportFilter): Promise<AxiosResponse<any>> {
		return super.getFileByFilter(filter, 'generate-fee-sk');
	}
}

export class ReportFilter extends BaseFilter{
	constructor(idMonth?: number | null, idSchoolYear?: number | null) {
		super();
		this._idMonth = idMonth;
		this._idSchoolYear = idSchoolYear;
	}

	private _idMonth?: number | null;
	private _idSchoolYear?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idMonth != null ? { IdMonth: this._idMonth } : {}),
			(this._idSchoolYear != null ? { IdSchoolYear: this._idSchoolYear } : {})
		);
		
		return data;
	};
}
